// OTP validity duration
const OTP_VALIDITY_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Save OTP session for a student
 * @param {number|string} studentId
 * @param {string} mobile
 */
export const saveOtpState = (studentId, mobile) => {
    const all = JSON.parse(localStorage.getItem("otp_sessions") || "{}");

    all[studentId] = {
        mobile,                     // store mobile number
        expiresAt: Date.now() + OTP_VALIDITY_MS, // expiry timestamp
    };

    localStorage.setItem("otp_sessions", JSON.stringify(all));
};

/**
 * Get OTP session for a student if valid
 * @param {number|string} studentId
 * @param {string} currentMobile
 * @returns {object|null} session info or null
 */
export const getOtpState = (studentId, currentMobile) => {
    const all = JSON.parse(localStorage.getItem("otp_sessions") || "{}");
    const entry = all[studentId];

    if (!entry) return null;

    // Check expiry
    if (Date.now() > entry.expiresAt) {
        delete all[studentId];
        localStorage.setItem("otp_sessions", JSON.stringify(all));
        return null;
    }

    // Check if current mobile matches stored mobile
    if (entry.mobile !== currentMobile) {
        return null; // mobile changed → hide OTP
    }

    return entry;
};

/**
 * Clear OTP session for a student
 * @param {number|string} studentId
 */
export const clearOtpState = (studentId) => {
    const all = JSON.parse(localStorage.getItem("otp_sessions") || "{}");
    delete all[studentId];
    localStorage.setItem("otp_sessions", JSON.stringify(all));
};
